import type { TDashboardFilter } from "@/ui/organisms/dashboardTypes";

export const projectKeys = {
    all: ["projects"] as const,
    list: (databaseIds: number[]) =>
        ["projects", "list", { databaseIds }] as const,
    detail: (projectId: number, databaseId: number) =>
        ["projects", "detail", { projectId, databaseId }] as const,
    files: (projectId: number, databaseId: number) =>
        ["projects", "files", { projectId, databaseId }] as const,
    propertyInfoForDelete: (
        propertyId: number,
        databaseId: number,
        projectId: number,
    ) =>
        [
            "projects",
            "propertyInfoForDelete",
            { propertyId, databaseId, projectId },
        ] as const,
    multipropDetail: (projectId: number, databaseId: number) =>
        ["projects", "multipropDetail", { projectId, databaseId }] as const,
};

export const userKeys = {
    all: ["user"] as const,
    data: () => ["user", "data"] as const,
};

export const databaseKeys = {
    all: ["databases"] as const,
    companies: () => ["databases", "companies"] as const,
};

export const configKeys = {
    all: ["config"] as const,
    googleMaps: () => ["config", "googleMaps"] as const,
};

export const analyticsKeys = {
    all: ["analytics"] as const,
    dashboard: (filter: TDashboardFilter) =>
        ["analytics", "dashboard", { filter }] as const,
};

export const adminKeys = {
    all: ["admin"] as const,
    databases: () => ["admin", "databases"] as const,
    coasForDatabases: (databaseIds: number[]) =>
        ["admin", "coasForDatabases", { databaseIds }] as const,
};

export const coaKeys = {
    all: ["coa"] as const,
    byDatabase: (databaseId: number) =>
        ["coa", "byDatabase", { databaseId }] as const,
    allForUser: () => ["coa", "allForUser"] as const,
    definition: (coaId: number) => ["coa", "definition", { coaId }] as const,
    accounts: (coaId: number) => ["coa", "accounts", { coaId }] as const,
    mappingTable: (coaId: number) =>
        ["coa", "mappingTable", { coaId }] as const,
    auditLogs: (coaId: number) => ["coa", "auditLogs", { coaId }] as const,
};

export const extractionKeys = {
    all: ["extraction"] as const,
    raw: (extractionId: number) =>
        ["extraction", "raw", { extractionId }] as const,
    standardized: (extractionId: number) =>
        ["extraction", "standardized", extractionId] as const,
    standardizedDetail: (
        extractionId: number,
        projectId: number,
        databaseId: number,
    ) =>
        [
            "extraction",
            "standardized",
            extractionId,
            { projectId, databaseId },
        ] as const,
    overlappingPeriods: (extractionId: number) =>
        ["extraction", "overlappingPeriods", extractionId] as const,
    overlappingPeriodsDetail: (
        extractionId: number,
        projectId: number,
        databaseId: number,
    ) =>
        [
            "extraction",
            "overlappingPeriods",
            extractionId,
            { projectId, databaseId },
        ] as const,
    labelset: (extractionId: number) =>
        ["extraction", "labelset", { extractionId }] as const,
    extractionType: (extractionId: number) =>
        ["extraction", "type", { extractionId }] as const,
    conflicts: (extractionId: number) =>
        ["extraction", "conflicts", extractionId] as const,
    conflictsDetail: (
        extractionId: number,
        projectId: number,
        databaseId: number,
    ) =>
        [
            "extraction",
            "conflicts",
            extractionId,
            { projectId, databaseId },
        ] as const,
    operatingStatementPeriods: (
        projectId: number,
        databaseId: number,
        annualizationType: string,
    ) =>
        [
            "extraction",
            "operatingStatementPeriods",
            { projectId, databaseId, annualizationType },
        ] as const,
    operatingStatement: (
        projectId: number,
        databaseId: number,
        params: object,
    ) =>
        [
            "extraction",
            "operatingStatement",
            { projectId, databaseId, params },
        ] as const,
};
